import React from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import toggleColorPicker from '../../../Functions/toggleColorPicker';
import getFonts from '../../../Functions/config/fonts';

const FieldStyles = ({ widget, handleInputChange, setColorsAndPreview }) => {
  const { monthlypayment } = widget.htmlData;
  const { fields } = monthlypayment;

  const fontOptions = getFonts().map(font => ({
    value: font,
    label: font
  }));

  const fontWeightOptions = [
    { value: 'normal', label: 'Normal' },
    { value: 'bold', label: 'Bold' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
    { value: '300', label: '300' },
    { value: '400', label: '400' },
    { value: '500', label: '500' },
    { value: '600', label: '600' },
    { value: '700', label: '700' },
    { value: '800', label: '800' },
    { value: '900', label: '900' }
  ];

  // Helper function to handle field changes with proper naming
  const handleFieldChange = (fieldType, fieldName, value) => {
    const fullFieldName = `fields-${fieldName}`;
    const processedValue = fieldType === 'fontSize' ? `${value}px` : value;
    handleInputChange({
      target: {
        name: fullFieldName,
        value: processedValue
      }
    });
  };

  const renderColorPicker = (label, color, fieldName) => (
    <div className="mjwi-row">
      <div className="mjwi-col50">
        <label>{label}</label>
      </div>
      <div className="mjwi-col50 mjwi-clr-picker">
        <span
          className="clrPickerVal"
          style={{ backgroundColor: color }}
          onClick={toggleColorPicker}
        ></span>
        <HexAlphaColorPicker
          color={color}
          onChange={(newColor) => setColorsAndPreview('fields', fieldName, newColor)}
          className="mjwi-apfl-color-picker"
        />
        <HexColorInput
          color={color}
          onChange={(newColor) => setColorsAndPreview('fields', fieldName, newColor)}
        />
      </div>
    </div>
  );

  const renderFontSize = (label, value, fieldName) => {
    const numericValue = parseInt(value) || 16;
    return (
      <div className="mjwi-row">
        <div className="mjwi-col50">
          <label>{label}</label>
        </div>
        <div className="mjwi-col50">
          <input
            type="number"
            value={numericValue}
            onChange={(e) => handleFieldChange('fontSize', fieldName, e.target.value)}
            className="mjwi-input"
            min="8"
            max="72"
          />
        </div>
      </div>
    );
  };

  const renderFontFamily = (label, value, fieldName) => (
    <div className="mjwi-row">
      <div className="mjwi-col50">
        <label>{label}</label>
      </div>
      <div className="mjwi-col50">
        <select
          value={value || 'Helvetica Neue'}
          onChange={(e) => handleFieldChange('fontFamily', fieldName, e.target.value)}
          className="mjwi-input"
        >
          {fontOptions.map((font) => (
            <option key={font.value} value={font.value}>
              {font.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );

  const renderFontWeight = (label, value, fieldName) => (
    <div className="mjwi-row">
      <div className="mjwi-col50">
        <label>{label}</label>
      </div>
      <div className="mjwi-col50">
        <select
          value={value || 'normal'}
          onChange={(e) => handleFieldChange('fontWeight', fieldName, e.target.value)}
          className="mjwi-input"
        >
          {fontWeightOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );

  const renderFieldSection = () => (
    <div className='mjwi-acc-panel-wrapper'>
      {renderColorPicker('Field Text Color', fields.textColor, 'textColor')}
      {renderFontSize('Field Font Size', fields.fontSize, 'fontSize')}
      {renderFontFamily('Field Font Family', fields.fontFamily, 'fontFamily')}
      {renderFontWeight('Field Font Weight', fields.fontWeight, 'fontWeight')}
    </div>
  );

  return (
    <div className="mjwi-panel">
      <div className="mjwi-accordability">
        <Accordion allowZeroExpanded={true}>
              {renderFieldSection()}
        </Accordion>
      </div>
    </div>
  );
};

export default FieldStyles;